import { Message } from "element-ui";
//封装弹框
const msgs = (type, msg1, msg2, time) => {
  if (msg1) {
    msg1 = `<span class="el-message-title-top">${msg1}</span>`;
  } else {
    msg1 = "";
  }
  if (msg2) {
    msg2 = `<p class="el-message-title-bottom">${msg2}</p>`;
  } else {
    msg2 = "";
  }
  let msg = {
    message: msg1 + msg2,
    dangerouslyUseHTMLString: true,
    duration: time || 1500,
    type: type,
  }
  if(type == 'success'){
    msg.iconClass = 'el-icon-circle-check'
  }
  Message(msg);
};
export default msgs;
